import { render, staticRenderFns } from "./HtSubmitButton.vue?vue&type=template&id=4c01b216&"
import script from "./HtSubmitButton.vue?vue&type=script&lang=js&"
export * from "./HtSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports